export default __webpack_public_path__ + "static/media/florayfauna2.840932b1.jpg";